import { insertTable } from './operations';

export const slashMenu = {
  Table: { icon: 'table', transform: insertTable },
};

export default slashMenu;
